import { render, staticRenderFns } from "./MainInfoColumnOverdue.vue?vue&type=template&id=65f06cce&scoped=true&"
import script from "./MainInfoColumnOverdue.vue?vue&type=script&lang=js&"
export * from "./MainInfoColumnOverdue.vue?vue&type=script&lang=js&"
import style0 from "./MainInfoColumnOverdue.vue?vue&type=style&index=0&id=65f06cce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f06cce",
  null
  
)

export default component.exports